export default {
  RESET_STORE(state) {
    Object.assign(state, {
      ...state,
      totalCount: 0,
      currentPageFacilities: [],
      selectedFacilities: [],
      initiallySelectedFacilities: [], // for adding to group dialog purposes
      allFacilitiesIds: [],
      cities: []
    });
  },

  SET_CURRENT_PAGE: (state, payload) => {
    state.currentPageFacilities = payload;
  },

  SET_SELECTED_FACILITIES: (state, payload) => {
    state.selectedFacilities = payload;
  },

  SET_INITIALLY_SELECTED_FACILITIES: (state, payload) => {
    state.initiallySelectedFacilities = payload;
  },

  SET_ALL_FACILITIES_IDS: (state, payload) => {
    state.allFacilitiesIds = payload;
  },

  SET_TOTAL_COUNT: (state, payload) => {
    state.totalCount = payload;
  },

  SET_CITIES: (state, payload) => {
    state.cities = payload;
  }
};
